// extracted by mini-css-extract-plugin
module.exports = {"container":"YoutubeBox_container__2LaSE","youtubeWrapper":"YoutubeBox_youtubeWrapper__1H_Ar","video":"YoutubeBox_video__ABj6Z"};